/// <amd-module name="Wit/UI/Utilities/HtmlFormatter" />

export function formatHtmlToPlainText(htmlText: string): string {
    return decodeHtmlSpecialChars(htmlText);
}

/**
 * Provides plain text context from a supplied html snippet.
 * 
 * Implemented by rendering content in a standalone untrusted document container and extracting the generated text.
 * 
 * The function of this layer is tag removal for HTML content from WIT HTML fields, which would otherwise be rendered on WIT forms. It provides textual content equivalent to the legacy decodeHtmlSpecialChars().
 * 
 * Service layer is ultimately responsible for sanitization of HTML content exposed to consumers of WIT form HTML data, 
 * but this implementation has been tested for unwanted script execution and image load traffic activity under IE11, Edge, Chrome and Firefox with Fiddler monitoring.
 */
function decodeHtmlSpecialChars(htmlText: string): string {
    const tmp = document.implementation.createHTMLDocument("").createElement("div");
    let result = "";
    if (htmlText != null) {
        tmp.innerHTML = htmlText;
        result = tmp.innerText || tmp.textContent || "";
    }

    return result;
}
